class GetArticleByIdUseCase {
    /**
     * @param {ArticleRepository} articleRepository
     */
    constructor(articleRepository) {
        this.articleRepository = articleRepository;
    }

    /**
     * @param {string} articleId
     * @returns {Promise<Article>}
     */
    async execute(articleId) {
        return this.articleRepository.getArticleById(articleId);
    }
}

export default GetArticleByIdUseCase;
